// FETCH ALL PROPERTIES FROM DEFAULT_STYLE MASTER
export const FETCH_DEFAULT_STYLE_MASTER_REQUEST = 'FETCH_DEFAULT_STYLE_MASTER_REQUEST';
export const FETCH_DEFAULT_STYLE_MASTER_SUCCESS = 'FETCH_DEFAULT_STYLE_MASTER_SUCCESS';
export const FETCH_DEFAULT_STYLE_MASTER_FAILURE = 'FETCH_DEFAULT_STYLE_MASTER_FAILURE';

// CREATE PROPERTIES FOR DEFAULT_STYLE MASTER
export const CREATE_DEFAULT_STYLE_MASTER_REQUEST = 'CREATE_DEFAULT_STYLE_MASTER_REQUEST';
export const CREATE_DEFAULT_STYLE_MASTER_SUCCESS = 'CREATE_DEFAULT_STYLE_MASTER_SUCCESS';
export const CREATE_DEFAULT_STYLE_MASTER_FAILURE = 'CREATE_DEFAULT_STYLE_MASTER_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_DEFAULT_STYLE_MASTER = 'CREATE_USER_FORM_DEFAULT_STYLE_MASTER';

//Type of material
export const TYPES_OF_MATERIALS_REQUEST = 'TYPES_OF_MATERIALS_REQUEST';
export const TYPES_OF_MATERIALS_SUCCESS = 'TYPES_OF_MATERIALS_SUCCESS';
export const TYPES_OF_MATERIALS_FAILURE = 'TYPES_OF_MATERIALS_FAILURE';

//SET_ACTIVE
export const DEFAULT_STYLE_MASTER_SET_ACTIVE_REQUEST = 'DEFAULT_STYLE_MASTER_SET_ACTIVE_REQUEST';
export const DEFAULT_STYLE_MASTER_SET_ACTIVE_SUCCESS = 'DEFAULT_STYLE_MASTER_SET_ACTIVE_SUCCESS';
export const DEFAULT_STYLE_MASTER_SET_ACTIVE_FAILURE = 'DEFAULT_STYLE_MASTER_SET_ACTIVE_FAILURE';

// FETCH SINGLE DEFAULT_STYLE
export const FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST = 'FETCH_SINGLE_DEFAULT_STYLE_MASTER_REQUEST';
export const FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS = 'FETCH_SINGLE_DEFAULT_STYLE_MASTER_SUCCESS';
export const FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE = 'FETCH_SINGLE_DEFAULT_STYLE_MASTER_FAILURE';

// UPDATE PROPERTIES FOR DEFAULT_STYLE
export const UPDATE_DEFAULT_STYLE_MASTER_REQUEST = 'UPDATE_DEFAULT_STYLE_MASTER_REQUEST';
export const UPDATE_DEFAULT_STYLE_MASTER_SUCCESS = 'UPDATE_DEFAULT_STYLE_MASTER_SUCCESS';
export const UPDATE_DEFAULT_STYLE_MASTER_FAILURE = 'UPDATE_DEFAULT_STYLE_MASTER_FAILURE';

// DELETE PROPERTIES FOR DEFAULT_STYLE MASTER
export const DELETE_DEFAULT_STYLE_MASTER_REQUEST = 'DELETE_DEFAULT_STYLE_MASTER_REQUEST';
export const DELETE_DEFAULT_STYLE_MASTER_SUCCESS = 'DELETE_DEFAULT_STYLE_MASTER_SUCCESS';
export const DELETE_DEFAULT_STYLE_MASTER_FAILURE = 'DELETE_DEFAULT_STYLE_MASTER_FAILURE';

//RESET DEFAULT_STYLE_MASTER_USER_FORM
export const RESET_DEFAULT_STYLE_MASTER_USER_FORM = 'RESET_DEFAULT_STYLE_MASTER_USER_FORM';
